import React from 'react';
import Modal from 'react-modal';
import { useModal as useModalHook } from 'react-modal-hook';

Modal.setAppElement('#root');

const modalStyles = {
  content: {
    border: 'none',
    bottom: 'unset',
    left: '0.3rem',
    overflow: 'visible',
    padding: 0,
    right: '0.3rem',
    top: '2.1rem'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)'
  }
};

function useModal(component: React.ComponentElement<any, any>, inputs?: any[]) {
  const [showModal, hideModal] = useModalHook(
    () => (
      <Modal isOpen={true} style={modalStyles}>
        {component}
      </Modal>
    ),
    inputs
  );

  return [showModal, hideModal];
}

const toastStyles = {
  content: {
    border: 'none',
    bottom: 'unset',
    left: '50%',
    overflow: 'visible',
    padding: 0,
    right: 'unset',
    top: '40%',
    transform: 'translateX(-50%)'
  },
  overlay: {
    backgroundColor: 'transparent',
    pointerEvents: 'none'
  }
};

export function useToast(
  renderComponent: (show: any, hide: any) => React.ComponentElement<any, any>
) {
  const [showToast, hideToast] = useModalHook(() => (
    <Modal isOpen={true} style={toastStyles}>
      {renderComponent(showToast, hideToast)}
    </Modal>
  ));

  function showAlert() {
    showToast();

    setTimeout(() => {
      hideToast();
    }, 2000);
  }

  return [showAlert, hideToast];
}

export default useModal;
